export default function SquareExclamationIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='6.25 6.25 11.5 11.5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M7 7.83333V16.1667C7 16.6269 7.3731 17 7.83333 17H16.1667C16.6269 17 17 16.6269 17 16.1667V7.83333C17 7.37309 16.6269 7 16.1667 7H7.83333C7.3731 7 7 7.3731 7 7.83333Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M12 9.5V12.2083' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12 14.4999C11.8849 14.4999 11.7917 14.4066 11.7917 14.2916C11.7917 14.1765 11.8849 14.0833 12 14.0833'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 14.4999C12.1151 14.4999 12.2083 14.4066 12.2083 14.2916C12.2083 14.1765 12.1151 14.0833 12 14.0833'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
